import { useContext } from "react";

import { TenantContext } from "../../../templates/context/TenantContext";

import { Icon } from "@aidron/aidron-ds";

import { 
  CustomCard,
  CustomHeading,
  CustomText
} from "../../StyledComponents/styleComponents.index"

import { formatAdjustPlanIndex } from "../../../utils/utils";

import PropTypes from "prop-types";

export function SumCard({ ctx, uiState }) {

  const { number, label, prefix } = ctx || {};
  const { icon, numberColor } = uiState || {};

  const { unit } = useContext(TenantContext);

  return (
    <CustomCard backgroundColor="lightGrey" style={{ borderRadius: "1rem", padding: "0.5rem" }}>
      <div style={{ display: 'grid', gridTemplateColumns: "0.5fr 1.5fr" }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Icon icon={icon} size={40} color="color-neutral-40" />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center" }}>
          <CustomHeading fontSize={['0.3rem', '0.8rem', '1rem']} color={numberColor ?? ""} margin="0">
            {`${prefix ?? ""} ${formatAdjustPlanIndex(Math.abs(number), unit)}`}
          </CustomHeading>
          
          <CustomText fontSize={['0.3rem', '0.7rem', '1rem']} weight="bold">{label}</CustomText>
        </div>
      </div>
    </CustomCard>
  );
}

SumCard.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape(),
}